import { render } from "./AgoraTestPage.vue?vue&type=template&id=4e194bd9&scoped=true&bindings={\"option\":\"data\",\"disableJoin\":\"data\",\"localStream\":\"data\",\"remoteStreams\":\"data\",\"message\":\"props\",\"joinEvent\":\"options\",\"leaveEvent\":\"options\",\"judge\":\"options\"}"
import script from "./AgoraTestPage.vue?vue&type=script&lang=js"
export * from "./AgoraTestPage.vue?vue&type=script&lang=js"

import "./AgoraTestPage.vue?vue&type=style&index=0&id=4e194bd9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e194bd9"

export default script